import React, { Component } from "react";
import { connect } from "react-redux";
import PageHeader from "../../../components/PageHeader";
import mainHelper, { apiCall } from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";
import ReactEcharts from "echarts-for-react";

class SalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            hasGenerated: false,
            warehouses: [],
            formData: {
                warehouse_id: '',
                start_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
                end_date: new Date().toISOString().split('T')[0],
            },
            reportData: {
                product_summary: [],
                warehouse_summary: [],
                monthly_data: [],
                totals: {},
                period: {}
            }
        };
    }

    componentDidMount() {
        this.fetchWarehouses();
    }

    fetchWarehouses = async () => {
        try {
            const response = await apiCall('business/stock/warehouse/select-list', 'get');
            if (response.status === 'success') {
                this.setState({ warehouses: response.data || [] });
            }
        } catch (e) {
            console.error('Depo listesi alınamadı:', e);
        }
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [name]: value
            }
        }));
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });

        try {
            const response = await apiCall(
                'business/stock/report/sales',
                'post',
                JSON.stringify(this.state.formData),
                { 'Content-Type': 'application/json' }
            );

            if (response.status === 'success') {
                this.setState({
                    reportData: response.data,
                    hasGenerated: true
                });
            } else {
                mainHelper.toastMessage('error', response.message || 'Rapor oluşturulamadı');
            }
        } catch (e) {
            console.error(e);
            mainHelper.toastMessage('error', 'Rapor oluşturulurken hata oluştu');
        }

        this.setState({ loading: false });
    };

    getMonthlyChartOption = () => {
        const { monthly_data } = this.state.reportData;

        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: (params) => {
                    const result = params.map(item => {
                        return `${item.seriesName}: ${item.value} adet`;
                    }).join('<br/>');
                    return `${params[0].name}<br/>${result}`;
                }
            },
            legend: {
                data: ['Satış', 'İade', 'Net Satış'],
                top: 0
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: monthly_data.map(item => item.month),
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    textStyle: {
                        color: "#C2C2C2",
                    },
                },
            },
            yAxis: {
                type: 'value',
                name: 'Miktar (adet)',
                axisLabel: {
                    formatter: '{value}',
                    textStyle: {
                        color: "#C2C2C2",
                    },
                },
                splitLine: {
                    lineStyle: {
                        type: "dotted",
                    },
                },
                axisLine: {
                    show: false,
                },
            },
            series: [
                {
                    name: 'Satış',
                    type: 'bar',
                    data: monthly_data.map(item => item.sales_quantity),
                    itemStyle: {
                        color: 'rgba(75, 192, 192, 0.8)'
                    }
                },
                {
                    name: 'İade',
                    type: 'bar',
                    data: monthly_data.map(item => item.return_quantity),
                    itemStyle: {
                        color: 'rgba(255, 99, 132, 0.8)'
                    }
                },
                {
                    name: 'Net Satış',
                    type: 'bar',
                    data: monthly_data.map(item => item.net_quantity),
                    itemStyle: {
                        color: 'rgba(54, 162, 235, 0.8)'
                    }
                }
            ]
        };
    };

    getMonthlyValueChartOption = () => {
        const { monthly_data } = this.state.reportData;

        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                },
                formatter: (params) => {
                    const result = params.map(item => {
                        return `${item.seriesName}: ${this.formatCurrency(item.value)}`;
                    }).join('<br/>');
                    return `${params[0].name}<br/>${result}`;
                }
            },
            legend: {
                data: ['Satış Tutarı', 'İade Tutarı', 'Net Tutar'],
                top: 0
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: monthly_data.map(item => item.month),
                boundaryGap: false,
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    textStyle: {
                        color: "#C2C2C2",
                    },
                },
            },
            yAxis: {
                type: 'value',
                name: 'Tutar (₺)',
                axisLabel: {
                    formatter: '{value}',
                    textStyle: {
                        color: "#C2C2C2",
                    },
                },
                splitLine: {
                    lineStyle: {
                        type: "dotted",
                    },
                },
                axisLine: {
                    show: false,
                },
            },
            series: [
                {
                    name: 'Satış Tutarı',
                    type: 'line',
                    data: monthly_data.map(item => item.sales_value),
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(75, 192, 192, 1)'
                    },
                    lineStyle: {
                        width: 3
                    }
                },
                {
                    name: 'İade Tutarı',
                    type: 'line',
                    data: monthly_data.map(item => item.return_value),
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(255, 99, 132, 1)'
                    },
                    lineStyle: {
                        width: 3
                    }
                },
                {
                    name: 'Net Tutar',
                    type: 'line',
                    data: monthly_data.map(item => item.net_value),
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(54, 162, 235, 1)'
                    },
                    lineStyle: {
                        width: 3
                    }
                }
            ]
        };
    };

    formatCurrency = (value) => {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY'
        }).format(value);
    };

    render() {
        const { loading, hasGenerated, warehouses, formData, reportData } = this.state;
        const { product_summary, warehouse_summary, monthly_data, totals } = reportData;

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Satış Raporu"
                            Breadcrumb={[
                                { name: "Raporlar", navigate: "" },
                                { name: "Stok Raporları", navigate: "" },
                                { name: "Satış Raporu", navigate: "" },
                            ]}
                        />

                        {/* Filtreler */}
                        <div className="row clearfix">
                            <div className="col-lg-12 col-md-12">
                                <div className="card">
                                    <div className="header">
                                        <h2>Rapor Filtreleri</h2>
                                    </div>
                                    <div className="body">
                                        <form onSubmit={this.handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Depo (Opsiyonel)</label>
                                                        <select
                                                            name="warehouse_id"
                                                            className="form-control"
                                                            value={formData.warehouse_id}
                                                            onChange={this.handleChange}
                                                        >
                                                            <option value="">Tüm Depolar</option>
                                                            {warehouses.map(warehouse => (
                                                                <option key={warehouse.id} value={warehouse.id}>
                                                                    {warehouse.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Başlangıç Tarihi</label>
                                                        <input
                                                            type="date"
                                                            name="start_date"
                                                            className="form-control"
                                                            value={formData.start_date}
                                                            onChange={this.handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Bitiş Tarihi</label>
                                                        <input
                                                            type="date"
                                                            name="end_date"
                                                            className="form-control"
                                                            value={formData.end_date}
                                                            onChange={this.handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>&nbsp;</label>
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary btn-block"
                                                            disabled={loading}
                                                            style={{textAlign: "-webkit-center"}}>
                                                            {loading ? (
                                                                <ReactLoading type="spin" width={'20px'} height={'20px'} color="#fff" />
                                                            ) : (
                                                                <>
                                                                    <i className="icon-bar-chart"></i> Rapor Oluştur
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* İlk mesaj */}
                        {!loading && !hasGenerated && (
                            <div className="row clearfix">
                                <div className="col-12">
                                    <div className="alert alert-info text-center">
                                        <i className="icon-info"></i> Raporu görmek için yukarıdaki filtreleri ayarlayıp "Rapor Oluştur" butonuna tıklayın.
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Rapor Sonuçları */}
                        {hasGenerated && !loading && (
                            <>
                                {/* Genel Toplam Kartları */}
                                <div className="row clearfix">
                                    <div className="col-lg-3 col-md-6">
                                        <div className="card">
                                            <div className="body text-center">
                                                <div className="icon-in-bg bg-success text-white shadow-sm" style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    borderRadius: '10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: '0 auto 15px'
                                                }}>
                                                    <i className="icon-basket-loaded" style={{fontSize: '24px'}}></i>
                                                </div>
                                                <h6 className="text-muted mb-0">Toplam Satış</h6>
                                                <h3 className="mb-0">{Math.round(totals.sales_quantity || 0)} adet</h3>
                                                <small className="text-success">{this.formatCurrency(totals.sales_value || 0)}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="card">
                                            <div className="body text-center">
                                                <div className="icon-in-bg bg-danger text-white shadow-sm" style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    borderRadius: '10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: '0 auto 15px'
                                                }}>
                                                    <i className="icon-action-undo" style={{fontSize: '24px'}}></i>
                                                </div>
                                                <h6 className="text-muted mb-0">Toplam İade</h6>
                                                <h3 className="mb-0">{Math.round(totals.return_quantity || 0)} adet</h3>
                                                <small className="text-danger">{this.formatCurrency(totals.return_value || 0)}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="card">
                                            <div className="body text-center">
                                                <div className="icon-in-bg bg-info text-white shadow-sm" style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    borderRadius: '10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: '0 auto 15px'
                                                }}>
                                                    <i className="icon-calculator" style={{fontSize: '24px'}}></i>
                                                </div>
                                                <h6 className="text-muted mb-0">Net Satış</h6>
                                                <h3 className="mb-0">{Math.round(totals.net_quantity || 0)} adet</h3>
                                                <small className="text-info">{this.formatCurrency(totals.net_value || 0)}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="card">
                                            <div className="body text-center">
                                                <div className="icon-in-bg bg-warning text-white shadow-sm" style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    borderRadius: '10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: '0 auto 15px'
                                                }}>
                                                    <i className="icon-graph" style={{fontSize: '24px'}}></i>
                                                </div>
                                                <h6 className="text-muted mb-0">İade Oranı</h6>
                                                <h3 className="mb-0">
                                                    {totals.sales_quantity > 0
                                                        ? ((totals.return_quantity / totals.sales_quantity) * 100).toFixed(1)
                                                        : 0}%
                                                </h3>
                                                <small className="text-muted">İade / Satış</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Grafikler */}
                                {monthly_data && monthly_data.length > 0 && (
                                    <div className="row clearfix">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h2>Aylık Satış ve İade Miktarları</h2>
                                                </div>
                                                <div className="body">
                                                    <ReactEcharts
                                                        option={this.getMonthlyChartOption()}
                                                        style={{ height: '400px', width: '100%' }}
                                                        opts={{ renderer: 'svg' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h2>Aylık Satış ve İade Tutarları (₺)</h2>
                                                </div>
                                                <div className="body">
                                                    <ReactEcharts
                                                        option={this.getMonthlyValueChartOption()}
                                                        style={{ height: '400px', width: '100%' }}
                                                        opts={{ renderer: 'svg' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Depo Bazında Özet */}
                                {warehouse_summary && warehouse_summary.length > 0 && (
                                    <div className="row clearfix">
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h2>Depo Bazında Satış Özeti</h2>
                                                </div>
                                                <div className="body">
                                                    <div className="table-responsive">
                                                        <table className="table table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Depo</th>
                                                                    <th className="text-right">Satış Miktarı</th>
                                                                    <th className="text-right">Satış Tutarı</th>
                                                                    <th className="text-right">İade Miktarı</th>
                                                                    <th className="text-right">İade Tutarı</th>
                                                                    <th className="text-right">Net Miktar</th>
                                                                    <th className="text-right">Net Tutar</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {warehouse_summary.map((warehouse, index) => (
                                                                    <tr key={index}>
                                                                        <td><strong>{warehouse.warehouse_name}</strong></td>
                                                                        <td className="text-right text-success">{Math.round(warehouse.sales_quantity)} adet</td>
                                                                        <td className="text-right text-success">{this.formatCurrency(warehouse.sales_value)}</td>
                                                                        <td className="text-right text-danger">{Math.round(warehouse.return_quantity)} adet</td>
                                                                        <td className="text-right text-danger">{this.formatCurrency(warehouse.return_value)}</td>
                                                                        <td className="text-right text-info"><strong>{Math.round(warehouse.net_quantity)} adet</strong></td>
                                                                        <td className="text-right text-info"><strong>{this.formatCurrency(warehouse.net_value)}</strong></td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Ürün Bazında Detay */}
                                {product_summary && product_summary.length > 0 && (
                                    <div className="row clearfix">
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="header">
                                                    <h2>Ürün Bazında Satış Detayı ({product_summary.length} Ürün)</h2>
                                                </div>
                                                <div className="body">
                                                    <div className="table-responsive">
                                                        <table className="table table-hover table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th>Ürün Adı</th>
                                                                    <th>SKU</th>
                                                                    <th className="text-right">Birim Fiyat</th>
                                                                    <th className="text-right">Satış Miktarı</th>
                                                                    <th className="text-right">Satış Tutarı</th>
                                                                    <th className="text-right">İade Miktarı</th>
                                                                    <th className="text-right">İade Tutarı</th>
                                                                    <th className="text-right">Net Miktar</th>
                                                                    <th className="text-right">Net Tutar</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {product_summary.map((product, index) => (
                                                                    <tr key={index}>
                                                                        <td><strong>{product.stock_item_name}</strong></td>
                                                                        <td><span className="badge badge-secondary">{product.sku}</span></td>
                                                                        <td className="text-right">{this.formatCurrency(product.unit_price)}</td>
                                                                        <td className="text-right text-success">{Math.round(product.sales_quantity)} adet</td>
                                                                        <td className="text-right text-success">{this.formatCurrency(product.sales_value)}</td>
                                                                        <td className="text-right text-danger">{Math.round(product.return_quantity)} adet</td>
                                                                        <td className="text-right text-danger">{this.formatCurrency(product.return_value)}</td>
                                                                        <td className="text-right text-info"><strong>{Math.round(product.net_quantity)} adet</strong></td>
                                                                        <td className="text-right text-info"><strong>{this.formatCurrency(product.net_value)}</strong></td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Veri yoksa mesaj */}
                                {product_summary && product_summary.length === 0 && (
                                    <div className="row clearfix">
                                        <div className="col-12">
                                            <div className="alert alert-warning text-center">
                                                <i className="icon-info"></i> Seçilen tarih aralığında satış veya iade hareketi bulunamadı.
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = () => ({});
export default connect(mapStateToProps, {})(SalesReport);

